import React, { useState } from 'react'
import { UserCard } from 'react-ui-cards'

/* LIBS */
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'

/* IMGS */

import { images } from '../Assets/IMGS/images'

const ButtonComponent = props => {
  const exames = []

  const [openDialogs, setOpenDialogs] = useState(
    Array(exames.length).fill(false)
  )

  const handleClickOpen = i => {
    const newOpenDialogs = [...openDialogs]
    newOpenDialogs[i] = true
    setOpenDialogs(newOpenDialogs)
  }

  const handleClose = i => {
    const newOpenDialogs = [...openDialogs]
    newOpenDialogs[i] = false
    setOpenDialogs(newOpenDialogs)
  }

  return (
    <>
      <React.Fragment>
        <Button id="buttons-clinica-page" onClick={() => handleClickOpen(1)}>
          Veja Nossos Exames
        </Button>

        <Dialog
          open={openDialogs[1]}
          onClose={() => handleClose(1)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title-clinica-page">
            Lista de nossos exames
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-clinica-page">
              {props.exames}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleClose(1)}
              id="alert-dialog-close-clinica-page"
            >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  )
}

const ButtonHorariosComponent = props => {
  const exames = []

  const [openDialogs, setOpenDialogs] = useState(
    Array(exames.length).fill(false)
  )

  const handleClickOpen = i => {
    const newOpenDialogs = [...openDialogs]
    newOpenDialogs[i] = true
    setOpenDialogs(newOpenDialogs)
  }

  const handleClose = i => {
    const newOpenDialogs = [...openDialogs]
    newOpenDialogs[i] = false
    setOpenDialogs(newOpenDialogs)
  }

  return (
    <>
      <React.Fragment>
        <Button id="buttons-clinica-page" onClick={() => handleClickOpen(1)}>
          Veja Nossos Horários
        </Button>

        <Dialog
          open={openDialogs[1]}
          onClose={() => handleClose(1)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title-clinica-page">
            Horários{' '}
          </DialogTitle>

          <DialogContent>
            <DialogContentText id="alert-dialog-clinica-page">
              {props.horario}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={() => handleClose(1)}
              id="alert-dialog-close-clinica-page"
            >
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  )
}

const Clinicas = () => {
  return (
    <>
      <main>
        <section className="novaAmerica">
          <div className="container-clinica">
            <div className="content-clinica">
              <h2>Clínica Nova América</h2>
              <p>Cuidando do seu bem estar</p>
              <div className="buttons">
                <ButtonComponent
                  exames={
                    <p>
                      Audiometria
                      <br />
                      Visual
                      <br />
                      laboratoriais
                      <br />
                      Eletrocardiograma
                      <br />
                      Eletroencefalograma
                      <br />
                      Espirometria
                    </p>
                  }
                />
                <ButtonHorariosComponent
                  horario={
                    <p className="p-dialog-clinica-page">
                      Funcionamento: De Seg à Sex das 08hrs às 17hrs <br />
                      Atendimento: De Seg à Sex das 08hrs às 12hrs <br />
                    </p>
                  }
                />
              </div>
            </div>
            <div className="location-clinicas">
              <UserCard
                float
                href={'https://maps.app.goo.gl/GWGZy49nHpwy16WK7'}
                target="_blank"
                header={images.novaAmerica}
                positionName="Av. Pastor Martin Luther King Júnior, 126 Shopping Nova América Office 3000, Sala 1009, Rio de Janeiro - RJ"
              />
            </div>
          </div>
        </section>{' '}
        <hr />
        <section className="centro">
          <div className="container-clinica">
            <div className="location-clinicas">
              <UserCard
                float
                href={'https://maps.app.goo.gl/Qi6k7wuWvrsFVsgn8'}
                target="_blank"
                header={images.uruguaiana}
                positionName="Av.  Presidente  Vargas   435, SALA 1502,  Centro,  Rio de Janeiro  -  RJ,  20071-904, (Próximo a estação uruguaina do metro)"
                name="Uruguaiana - Centro"
              />
            </div>{' '}
            <div className="content-clinica">
              <h2>Clinica Centro</h2>
              <p>Cuidando do seu bem estar</p>
              <div className="buttons">
                <ButtonComponent
                  exames={
                    <p>
                      Audiometria
                      <br />
                      Visual
                      <br />
                      laboratoriais
                      <br />
                      Eletrocardiograma
                      <br />
                      Eletroencefalograma
                      <br />
                      Raio-X
                      <br />
                      Espirometria
                    </p>
                  }
                />
                <ButtonHorariosComponent
                  horario={
                    <p className="p-dialog-clinica-page">
                      Seg: 08hrs - 17hrs <br />
                      Ter: 08hrs - 17hrs <br />
                      Qua: 08hrs - 17hrs <br />
                      Qui: 08hrs - 17hrs <br />
                      Sex: 08hrs - 17hrs <br />
                    </p>
                  }
                />
              </div>
            </div>
          </div>
        </section>
        <hr />
        <section className="barra">
          <div className="container-clinica">
            <div className="content-clinica">
              <h2>Clinica Barra da Tijuca</h2>
              <p>Cuidando do seu bem estar</p>
              <div className="buttons">
                <ButtonComponent
                  exames={
                    <p>
                      Audiometria
                      <br />
                      Visual
                      <br />
                      laboratoriais
                      <br />
                      Eletrocardiograma
                      <br />
                      Eletroencefalograma
                      <br />
                      Raio-X
                      <br />
                      Espirometria
                    </p>
                  }
                />
                <ButtonHorariosComponent
                  horario={
                    <p className="p-dialog-clinica-page">
                      Seg: 08hrs - 17hrs <br />
                      Qua: 08hrs - 17hrs <br />
                      Sex: 08hrs - 17hrs <br />
                    </p>
                  }
                />
              </div>
            </div>
            <div className="location-clinicas">
              <UserCard
                float
                href={'https://maps.app.goo.gl/m4S9xWJJQrxczFpi9'}
                target="_blank"
                header={images.dimension}
                positionName="Av. Abelardo Bueno, 1 - loja 108 , Barra da Tijuca,  22790-703. (Em frente a Estação Centro-Metropolitano do BRT)"
                name="Barra da Tijuca"
              />
            </div>
          </div>
        </section>
      </main>
      );
    </>
  )
}

export default Clinicas
